const SampleNextArrow = (props) => {
  const {
    className,
    style,
    onClick,
    marginTop,
    currentSlide,
    slideCount,
    marginRight,
  } = props;
  const disabled = currentSlide === slideCount - 1;

  return (
    <div
      className={`${className} ${disabled ? "slick-disabled" : ""} `}
      style={{
        ...style,
        // display: block;
        cursor: disabled ? "none" : "",
        background: "rgba(0, 0, 0, 0.25)",
        height: "40px",
        borderRadius: "40px",
        marginTop: marginTop,
        width: "40px",
        padding: "10px",
        fontWeight: "700",
        marginRight: marginRight,
        zIndex: 10,
      }}
      onClick={!disabled ? onClick : undefined}
    >
      {"-->"}
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const {
    className,
    style,
    onClick,
    marginTop,
    marginRight,
    currentSlide,
    marginLeft,
  } = props;

  const disabled = currentSlide === 0;
  return (
    <div
      className={`${className} ${disabled ? "slick-disabled" : ""}`}
      style={{
        ...style,
        background: "rgba(0, 0, 0, 0.25)",
        height: "40px",
        marginTop: marginTop,
        borderRadius: "40px",
        width: "40px",
        padding: "10px",
        fontWeight: "700",
        marginRight: marginRight,
        marginLeft: marginLeft,
        zIndex: 10,
      }}
      onClick={!disabled ? onClick : undefined}
    />
  );
};

export { SamplePrevArrow, SampleNextArrow };
